import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NosotrosComponent } from './components/pages/nosotros/nosotros.component';
import { AcopiosComponent } from './components/pages/acopios/acopios.component';
import { CertificacionesComponent } from './components/pages/certificaciones/certificaciones.component';
import { ProductosComponent } from './components/pages/productos/productos.component';
import { GaleriaComponent } from './components/pages/galeria/galeria.component';
import { ContactoComponent } from './components/pages/contacto/contacto.component';
import { ErrorComponent } from './components/pages/error/error.component';
import { AvisosComponent } from './components/pages/vinculacion/avisos/avisos.component';
import { EmpresaComponent } from './components/pages/vinculacion/empresa/empresa.component';
import { SociedadComponent } from './components/pages/vinculacion/sociedad/sociedad.component';
import { FloracionesComponent } from './components/pages/floraciones/floraciones.component';
import { DetalleEmpresaComponent } from './components/pages/vinculacion/detalle-empresa/detalle-empresa.component';
import { DetalleSociedadComponent } from './components/pages/vinculacion/detalle-sociedad/detalle-sociedad.component';
import { AvisosPrivacidadComponent } from './components/pages/avisos_privacidad/avisos.component';
import { MarcasComponent } from './components/pages/productos/marcas.component';

const routes: Routes = [
    { path: '', component: NosotrosComponent },
    { path: 'proveedores', component: AcopiosComponent },
    { path: 'certificaciones', component: CertificacionesComponent },
    { path: 'floraciones', component: FloracionesComponent },
    { path: 'marcas', component: MarcasComponent },
    { path: 'productos/:idMarca', component: ProductosComponent },
    { path: 'avisos', component: AvisosComponent },
    { path: 'empresa', component: EmpresaComponent },
    { path: 'detalle-empresa/:idEmpresa', component: DetalleEmpresaComponent },
    { path: 'detalle-sociedad/:idSociedad', component: DetalleSociedadComponent },
    { path: 'sociedad', component: SociedadComponent },
    { path: 'galeria', component: GaleriaComponent },
    { path: 'contacto', component: ContactoComponent },
    { path: 'error', component: ErrorComponent },
    { path: 'avisos-privacidad', component: AvisosPrivacidadComponent },
    // Here add new component

    { path: '**', component: ErrorComponent } // This line will remain down from the whole component list
];

// @NgModule({
//     imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
//     exports: [RouterModule]
// })

@NgModule({
    imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy', useHash: true })],
    exports: [RouterModule]
})
export class AppRoutingModule { }